// Nom du fichier partagé. Décision des fondateurs du 22/09 : « le partage revient, mais en
// image ». L'image quitte le site — son nom est la première chose qu'un destinataire lit,
// souvent la seule avant de l'ouvrir, et il doit survivre à un partage Android, à une pièce
// jointe de messagerie et au dossier « Téléchargements » d'un poste de mairie sous Windows.
//
// D'où : minuscules, sans accent, sans espace. Pas par coquetterie — un « é » se retrouve
// encodé « %C3%A9 » dans une URL de téléchargement, et certains clients de messagerie
// tronquent au premier caractère qu'ils ne savent pas écrire.

/** Longueur maximale, extension comprise — bien en deçà des 255 octets de la plupart des
 *  systèmes de fichiers, parce que le nom doit aussi rester LISIBLE dans une liste. */
const LONGUEUR_MAX = 120
const PREFIXE = 'terobs'

/** Réduit un libellé humain à un morceau de nom de fichier (ou d’identifiant SVG, pour le
 *  composeur de cartes). Vide si rien n’est nommable. */
export function morceau(texte: string): string {
  return texte
    // NFD sépare la lettre de son accent, la plage ̀-ͯ retire l'accent seul :
    // « é » devient « e », jamais « ? » ni un octet perdu.
    .normalize('NFD').replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    // Tout ce qui n'est ni lettre ni chiffre devient un tiret — y compris « / » et « \ »,
    // qui dans un attribut `download` seraient une écriture hors du dossier de destination.
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
}

/** Les formats d'export : le PNG de la messagerie, le SVG vectoriel (30/09). */
export type FormatImage = 'png' | 'svg'

/**
 * `terobs-<commune>-<indicateur>.<png|svg>`, en minuscules et sans accents.
 *
 * Les morceaux vides sont écartés plutôt que rendus : « terobs--.png » est refusé par
 * certaines messageries, et le partage échouerait sans que l'utilisateur sache pourquoi.
 * Le PNG et le SVG d'un même objet portent le même nom : seule l'extension les distingue,
 * et c'est ce qu'on veut retrouver côte à côte dans un dossier.
 */
export function nomFichierPartage(commune: string, indicateur: string,
                                  format: FormatImage = 'png'): string {
  const extension = `.${format}`
  const morceaux = [commune, indicateur].map(morceau).filter(Boolean)
  if (morceaux.length === 0) return `${PREFIXE}${extension}`
  let base = [PREFIXE, ...morceaux].join('-')
  if (base.length > LONGUEUR_MAX - extension.length) {
    // On coupe puis on retire le tiret de queue : « …-vacants-.png » ferait croire à un
    // fichier tronqué par accident, alors que c'est nous qui avons borné.
    base = base.slice(0, LONGUEUR_MAX - extension.length).replace(/-+$/, '')
  }
  return `${base}${extension}`
}
